import React from 'react'
import classNames from 'classnames'

import { IUserInfoResponse } from 'protos'

import Grid from '@material-ui/core/Grid'
import Avatar from '@material-ui/core/Avatar'
import Typography from '@material-ui/core/Typography'

import Jersey from 'components/Jersey'
import PlayerPosition from 'components/PlayerPosition'

import VitalStatisticsRow from './VitalStatisticsRow'
import { createStyles, WithStyles, withStyles, Theme } from '@material-ui/core/styles'

interface Props {
  topPlayerScore?: IUserInfoResponse['topPlayerScore']
}

const styles = (theme: Theme) => createStyles({
  whiteBg: {
    backgroundColor: 'white',
  },
  bordered: {
    borderWidth: 1,
    borderColor: theme.palette.grey['50'],
    borderStyle: 'solid',
  },
  marginRight: {
    marginRight: theme.spacing(),
  },
})

type InjectedProps = Props & WithStyles<typeof styles>

const VitalStatisticsPlayer: React.SFC<InjectedProps> = ({
  classes,
  topPlayerScore,
}) => (
    <VitalStatisticsRow point={topPlayerScore!.score!}>
      <Grid container direction="row" wrap="nowrap">
        <Grid className={classes.marginRight} item>
          <Avatar className={classNames(classes.whiteBg, classes.bordered)}>
            <Jersey jersey={topPlayerScore!.player!.jersey!} />
          </Avatar>
        </Grid>
        <Grid item>
          <Typography variant="body1">
            {topPlayerScore!.player!.name}
          </Typography>
          <Typography variant="caption" color="textSecondary">
            (<PlayerPosition position={topPlayerScore!.player!.position} variant="short" />)
            &nbsp;
            {topPlayerScore!.player!.team!.name}
          </Typography>
        </Grid>
      </Grid>
    </VitalStatisticsRow>
  )

export default withStyles(styles)(VitalStatisticsPlayer)
